import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ResponseStatusEnum } from 'src/app/shared/models/system/response-status.enum';
import { Globals } from 'src/app/shared/services/globals';
import { DoctorsService } from '../../sas/services/doctors.service';
import { Doctor } from 'src/app/shared/models/DTO/Doctor';
import { SubSpeciality } from 'src/app/shared/models/DTO/SubSpeciality';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-doctor-profile',
  templateUrl: './doctor-profile.component.html',
  styleUrls: ['./doctor-profile.component.css']
})
export class DoctorProfileComponent implements OnInit {
  doctorId: number;
  doctor: Doctor = new Doctor();

  constructor(private _activatedRoute:ActivatedRoute, private router:Router, public _DoctorService: DoctorsService,
    public globals: Globals, private toastr: ToastrService) { }

  ngOnInit() {

    this._activatedRoute.params.subscribe(a =>{
      this.doctorId = a['doctorId'];
    });

    if(this.doctorId){
      this._DoctorService.GetDoctorById(this.doctorId).subscribe(
        (data:any) => {
          console.log("Doctor data : " , data);
          if(data.status !=-1){
            this.doctor= data.data;
            if (this.doctor.pictureUrl){
              this.doctor.pictureUrl = `${environment.API_URL}/../${this.doctor.pictureUrl}`;
            }
            else{
              this.doctor.pictureUrl = '../../../assets/images/doctor.png';
            }
          }
        },
        (error:any) =>{
          console.log(error);
          this.toastr.error("حدث خطأ ما.");
        });
   }
  }

}
